import { useEffect } from "react";

/** Exibe o snippet WhatsApp (Mundiale) apenas nas telas que usam este hook. */
export default function useMundialeChat() {
  useEffect(() => {
    window.__mundialeChatEnabled = true;
    window.dispatchEvent(new Event("mundiale:locationchange"));

    return () => {
      window.__mundialeChatEnabled = false;
      window.dispatchEvent(new Event("mundiale:locationchange"));
    };
  }, []);
}
